import { render, staticRenderFns } from "./init.vue?vue&type=template&id=53e780cc&scoped=true&"
import script from "./init.ts?vue&type=script&lang=ts&"
export * from "./init.ts?vue&type=script&lang=ts&"
import style0 from "./init.css?vue&type=style&index=0&id=53e780cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e780cc",
  null
  
)

component.options.__file = "init.vue"
export default component.exports